import styled from '@emotion/styled';
import { Badge } from '@kc-console/common-ui';
import { BadgeType, type ServiceBadge } from '@kc-console/context';

interface Props {
  badges: ServiceBadge[];
}

/**
 * BadgeType과 name에 따라 Badge color를 반환
 * - PHASE → black
 * - STATUS + name 'New' → purple
 * - STATUS + name 'Update' → blue
 */
function getBadgeColor(type: BadgeType, name: string) {
  if (type === BadgeType.PHASE) return 'black';
  if (type === BadgeType.STATUS) {
    const normalized = name.toLowerCase();
    if (normalized === 'new') return 'purple';
    if (normalized === 'update') return 'blue';
  }
  return 'gray';
}

function getBadgeVariant(type: BadgeType) {
  switch (type) {
    case BadgeType.PHASE:
      return 'filled';
    case BadgeType.STATUS:
      return 'outline';
    default:
      return 'filled';
  }
}

const ServiceBadgeList = ({ badges }: Props) => {
  if (!badges?.length) return null;

  return (
    <BadgeListWrapper>
      {badges.map(badge => (
        <Badge
          key={badge.id}
          label={badge.name}
          color={getBadgeColor(badge.type, badge.name)}
          variant={getBadgeVariant(badge.type)}
          shape="rectangular"
        />
      ))}
    </BadgeListWrapper>
  );
};

const BadgeListWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  margin-left: 4px;
`;

export default ServiceBadgeList;
